<template>
    <div>
        <sys-select-base
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            :clearable="clearable"
            :dense="dense"
            :disabled="disabled"
        />
    </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
    name: 'SysSelectGridStatus',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
    }),
    created() {
        this.getItems();
    },
    props: {
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {

        },
        dense: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        selected(val){
            this.$emit('update:model', val);
        },
        model(val){
            this.selected = val;
        },
    },
    methods: {
        ...mapActions('grid', ['ActionIndexGridStatuses']),

        async getItems() {

            this.loading = true;

            // O endpoint já devolve somente os status visíveis ao usuário (visible_to_user).
            await this.ActionIndexGridStatuses()
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },
    },
}
</script>
